if (!customElements.get('product-upsale')) {
  customElements.define('product-upsale', 
    class ProductUpsale extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.variantId = this.checkbox.dataset.variantId;
        if (!this.checkbox || !this.variantId) return;

        this.connectedCallback();
        this.setState();

        this.checkbox.addEventListener('change', () => {
          const quantity = this.checkbox.checked ? 1 : 0;
          const cartRoute = this.checkbox.checked ? routes.cart_add_url : routes.cart_change_url;
          this.updateCart(this.variantId, quantity, cartRoute);
          this.displayElements();
        });
      }

      cartUpdateSubscriber = undefined;

      connectedCallback() {
        this.cartUpdateSubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-upsale') {
            return;
          } else {
            if (!this.checkbox || !this.variantId) return;
            const upsellProductInCart = event.cartData.items.find(item => item.variant_id == this.variantId);
            this.checkbox.checked = upsellProductInCart ? true : false;
            this.displayElements();
          }
        })
      }

      setState() {
        fetch(`/cart.js`) 
          .then((response) => response.text())
          .then((cart) => {
            const cartData = JSON.parse(cart);
            const upsellProductInCart = cartData.items.find(item => item.variant_id == this.variantId);
            this.checkbox.checked = upsellProductInCart ? true : false;
          })
      }

      displayElements() {
        if (this.checkbox.checked) {
          this.querySelector('.upsale-container').classList.add('hidden');
          this.querySelector('.upsale-added-message').classList.remove('hidden');
        } else {
          this.querySelector('.upsale-container').classList.remove('hidden');
          this.querySelector('.upsale-added-message').classList.add('hidden');
        }
      }

      updateCart(variantId, quantity, cartRoute) {
        const cartItems = document.querySelector('cart-items');

        fetch(`${cartRoute}`, {
          ...fetchConfig(),
          body: JSON.stringify({
            id: variantId, 
            quantity: quantity,
            sections: cartItems.getSectionsToRender().map((section) => section.section)
          })
        })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          
          cartItems.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });

          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          // upsale section
          if (this.checkbox.checked) {
            const upsaleSection = document.getElementById('upsale-section');
          }
          publish(PUB_SUB_EVENTS.cartAdd, { source: 'product-upsale', cartData: parsedState });
        })
        .catch(err => {
          const errors = document.getElementById('cart-errors');
          errors.textContent = window.cartStrings.error;
        })
      }

    }
  )
}